import { NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import {PortalModule} from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// import { StoreService } from './service/store.service';
// import { EventBusService } from './service/event-bus.service';
// import { ErrorService } from './service/error.service';
// import { LeancloudService } from './service/leancloud.service';
// import { RouterService } from './service/router.service';

// import { ShopService } from './business-sevice/shop.service';
// import { TujiaService } from './business-sevice/tujia.service';
// import { AirbnbService } from './business-sevice/airbnb.service';
// import { ToolsService } from './business-sevice/tools.service';
// import { AuthorityService } from './business-sevice/authority.service';

// import { AuthGuard } from './guard/auth-guard.service';
// import { PiwikGuard } from './guard/piwik-guard.service';
// import { CanDeactivateGuard } from './guard/can-deactivate-guard.service';


//#region Thirdparty Modules
// import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgDragDropModule } from 'ng-drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { DelonACLModule } from "@delon/acl";
import SharedZorroAntdModules from './ng-zorro-antd';
const THIRDMODULES = [
  // NgZorroAntdModule, 
  NgDragDropModule, TranslateModule, DelonACLModule, 
  // ng-zorro-antd
  ...SharedZorroAntdModules
];
//#endregion

//#region Pipes
import { ThirdpartyPipe } from './pipes/thirdparty.pipe';
import { CurrencyToSymbolPipe } from './pipes/currency-to-symbol.pipe';
import { ValuesPipe } from './pipes/values.pipe';
import { WordCounterPipe } from './pipes/word-counter.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { HtmlPipe } from './pipes/html.pipe';
import { EmojiPipe } from './pipes/emoji.pipe';
import { JsonParsePipe } from './pipes/json-parse.pipe';
import {ReplacePipe} from "@root/shared/pipes/replace.pipe";
const PIPES = [
  ReplacePipe, ThirdpartyPipe, WordCounterPipe, EllipsisPipe, DateFormatPipe, HtmlPipe, EmojiPipe, JsonParsePipe, CurrencyToSymbolPipe, /** 之后管道功能重复或无通用性，待删除或修改 */  ValuesPipe
];
//#endregion

//#region Directives
import { PlaceholderDirective } from './directives/placeholder.directive';
import { InputNumberDirective } from './directives/input-number.directive';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { MaxCharactersDirective } from './directives/max-characters.directive';
import { ThrottleClickDirective } from './directives/throttle-click.directive';
import { RoomSortDragStartDirective } from './directives/room-sort-drag-start.directive';
import { ClipboardDirective } from '@root/shared/directives/clipboard.directive';
import { I18nImageSwitcherDirective } from './directives/i18n-image-switcher.directive';


const DIRECTIVES = [
  PlaceholderDirective, InputNumberDirective, AutoFocusDirective, MaxCharactersDirective, ClipboardDirective, I18nImageSwitcherDirective, /** 之后的指令无通用性，待移除 */ RoomSortDragStartDirective, ThrottleClickDirective
];
//#endregion

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    ...DIRECTIVES,
    ...PIPES,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    A11yModule,
    PortalModule,
    ReactiveFormsModule,
    // TranslateModule,
    // NgZorroAntdModule,
    // NgDragDropModule,
    ...THIRDMODULES,
    ...DIRECTIVES,
    ...PIPES,
  ],
})
export class SharedModule {
  /**
   * @deprecated
   * @todo
   * 之后的服务将通过服务内部的
   *    @Injectable({ providedIn: 'root' })
   * 的方式声明，不再通过这种方式声明
   */
  // static forRoot(): ModuleWithProviders {
  //   return {
  //     ngModule: SharedModule,
  //     providers: [
  //       // FormService,
  //       StoreService,
  //       EventBusService,
  //       ErrorService,
  //       LeancloudService,
  //       RouterService,
  //       ShopService,
  //       TujiaService,
  //       AirbnbService,
  //       ToolsService,
  //       AuthorityService,
  //       // MemberService,
  //       // { provide: NZ_NOTIFICATION_CONFIG, useValue: { nzMaxStack: 1 } },
  //       AuthGuard,
  //       PiwikGuard,
  //       CanDeactivateGuard,
  //     ],
  //   };
  // }
}
